import script from "./SignInSignUpAlert.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignInSignUpAlert.vue?vue&type=script&setup=true&lang=ts"

import "./SignInSignUpAlert.vue?vue&type=style&index=0&id=bf918c34&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf918c34"]])

export default __exports__